var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"ml-auto"},[_vm._v("\n\t\t\t123\n\t\t")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }